var _defs, _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".cls-1{fill:#004e8c;}.cls-2,.cls-3{fill:#fff;}.cls-2{opacity:0.1;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_vb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 32,
    cy: 32,
    r: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.82,9A32,32,0,1,0,55,54.18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.29,19.4,24,44.6H20.71L11.57,19.4h3.29l7,20a11.87,11.87,0,0,1,.51,2.23h.07A11,11,0,0,1,23,39.35l7.12-20Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.92,44.6V19.4h7.17A7.84,7.84,0,0,1,49.27,21a5.17,5.17,0,0,1,1.92,4.17A6.13,6.13,0,0,1,50,28.89a6.26,6.26,0,0,1-3.2,2.25v.07a6.41,6.41,0,0,1,4.08,1.92,5.92,5.92,0,0,1,1.53,4.23,6.59,6.59,0,0,1-2.32,5.24,8.64,8.64,0,0,1-5.85,2Zm3-22.54v8.14h3A5.74,5.74,0,0,0,46.71,29a4.07,4.07,0,0,0,1.39-3.3q0-3.67-4.83-3.67Zm0,10.79v9.07h4a6,6,0,0,0,4-1.23,4.21,4.21,0,0,0,1.43-3.37q0-4.46-6.08-4.46Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVb);
export default __webpack_public_path__ + "static/media/vb.55b70f15bd6c74f77ab8abef2d757151.svg";
export { ForwardRef as ReactComponent };